import React from 'react';
import { FederationMembersPage } from '../../components/FederationMembersPage';
const members = [{
  name: 'Київська обласна федерація',
  role: 'Відокремлений підрозділ — м. Київ'
}, {
  name: 'Львівська обласна федерація',
  role: 'Відокремлений підрозділ — м. Львів'
}, {
  name: 'Харківська обласна федерація',
  role: 'Відокремлений підрозділ — м. Харків'
}, {
  name: 'Одеська обласна федерація',
  role: 'Відокремлений підрозділ — м. Одеса'
}, {
  name: 'Дніпропетровська обласна федерація',
  role: 'Відокремлений підрозділ — м. Дніпро'
}, {
  name: 'Запорізька обласна федерація',
  role: 'Відокремлений підрозділ — м. Запоріжжя'
}];
export function Subdivisions() {
  return <FederationMembersPage title="Відокремлені підрозділи" subtitle="Регіональні представництва Федерації Альпінізму і Скелелазіння України" members={members} data-id="element-782" />;
}